import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { getEnvConfig } from './config';

// Idempotent accessor for the shared default Firebase app. Existing
// Connected-Class code (ClickerAssessmentContextProvider, Notification.tsx,
// etc.) each call initializeApp() unconditionally at their own call sites,
// which only avoids "Firebase App named '[DEFAULT]' already exists" errors
// because those specific call sites happen not to run in the same session
// today. New code (LiveQuiz) should go through this instead of adding another
// unconditional initializeApp() call.
export const getFirebaseApp = (): FirebaseApp => {
  if (getApps().length) {
    return getApp();
  }
  return initializeApp(getEnvConfig().firebaseConfig);
};
